import React from 'react'
import TransactionDetail from 'src/app/TransactionDetail/TransactionDetail'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import AccountTransactionsAppRoute from 'src/navigation/appRoutes/account/accountTransactions.appRoute'
import ExpensesTransactionsAppRoute from 'src/navigation/appRoutes/expenses/expensesTransactions.appRoute'
import {
  budgetTransactionsRouteProps,
  transactionDetailRouteProps,
} from 'src/navigation/routeProps'

import { AppLocation } from '../appLocations'

const TransactionDetailAppRoute: AppRoute = {
  id: AppLocation.TransactionDetail,
  routeProps: transactionDetailRouteProps,
  component: <TransactionDetail />,
  subRoutes: [],
  exceptions: [
    ExpensesTransactionsAppRoute,
    AccountTransactionsAppRoute,
    // Budgets migrated to flat routing (EX-39748); reference the routeProps
    // directly so this overlay still excludes the budget transactions page.
    { routeProps: budgetTransactionsRouteProps, subRoutes: [] },
  ],
  meta: { contentType: SidenavContentType.Main },
}

export default TransactionDetailAppRoute
